import { render, staticRenderFns } from "./alert-dialog.vue?vue&type=template&id=bb5970b4&scoped=true"
import script from "./alert-dialog.vue?vue&type=script&lang=js"
export * from "./alert-dialog.vue?vue&type=script&lang=js"
import style0 from "./alert-dialog.vue?vue&type=style&index=0&id=bb5970b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5970b4",
  null
  
)

export default component.exports